export const RESPONSIVE_FLUID_CLASSNAME = 'timesgrid-fluid';

export const PROCEDURE_IDS = {
    ILLNESS: '75',
    ANNUAL_PHYSICAL: '76',
    ORTHOPEDIC_CONSULTATION: '104',
    PLASTIC_SURGERY_CONSULTATION: '349',
};

export const SPECIALTY_IDS = {
    ALLERGIST: '132',
    COSMETIC_DENTIST: '333',
    DENTAL_PAIN_SPECIALIST: '334',
    DENTIST: '98',
    DERMATOLOGIST: '101',
    EMERGENCY_MEDICINE_PHYSICIAN: '146',
    ENDODONTIST: '134',
    EYE_DOCTOR: '386',
    FACIAL_PLASTIC_SURGEON: '167',
    FAMILY_PHYSICIAN: '102',
    IMMUNOLOGIST: '154',
    INTERNIST: '99',
    NATUROPATHIC: '373',
    OBGYN: '104',
    OPTHAMOLOGIST: '116',
    OPTOMETRIST: '157',
    ORAL_SURGEON: '151',
    ORTHODONTIST: '135',
    ORTHOPEDIC_SURGEON: '117',
    PEDIATRIC_DENTIST: '152',
    PEDIATRICIAN: '100',
    PERIODONTIST: '136',
    PHYSICIAN_ASSISTANT: '381',
    PLASTIC_SURGEON: '120',
    PRIMARY_CARE_PHYSICIAN: '153',
    PROSTHODONTIST: '137',
};

export const DENTAL_INSURANCE_SPECIALTIES = new Set([
    SPECIALTY_IDS.COSMETIC_DENTIST,
    SPECIALTY_IDS.DENTAL_PAIN_SPECIALIST,
    SPECIALTY_IDS.DENTIST,
    SPECIALTY_IDS.ENDODONTIST,
    SPECIALTY_IDS.ORAL_SURGEON,
    SPECIALTY_IDS.ORTHODONTIST,
    SPECIALTY_IDS.PEDIATRIC_DENTIST,
    SPECIALTY_IDS.PERIODONTIST,
    SPECIALTY_IDS.PROSTHODONTIST,
]);

export const VISION_INSURANCE_SPECIALTIES = new Set([
    SPECIALTY_IDS.EYE_DOCTOR,
    SPECIALTY_IDS.OPTHAMOLOGIST,
    SPECIALTY_IDS.OPTOMETRIST,
]);
export const HttpStatusCodes = {
    OK: 200,
    Created: 201,
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    UnprocessableEntity: 422,
};

export function ServerException({
    errorCode, response, bookingState, errorFields, message, type, code,
}) {
    this.errorCode = errorCode;
    this.response = response;
    this.bookingState = bookingState;
    this.errorFields = errorFields;
    this.message = message;
    this.type = type;
    this.code = code;
}

export const SearchParameterToQuery = {
    address: 'address',
    carrierId: 'insurance_carrier',
    dayFilter: 'day_filter',
    directoryId: 'directory_id',
    excludeSpecialties: 'exclude_specialties',
    genderFilter: 'gender',
    ip: 'ip',
    languageId: 'language',
    name: 'name',
    pageOffset: 'offset',
    planId: 'insurance_plan',
    practiceId: 'practiceId',
    procedureId: 'reason_visit',
    showProvidersWhoSeeChildren: 'sees_children',
    showTimesAfter5: 'after_5pm',
    showTimesBefore10: 'before_10am',
    sortType: 'sort_type',
    specialtyId: 'dr_specialty',
};
